import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Analyse from "@/pages/Analyse";
import Admin from "@/pages/Admin";
import WhatsAppButton from "@/components/WhatsAppButton";
import AIChatWidget from "@/components/AIChatWidget";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/analyse" element={<Analyse />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
                <WhatsAppButton />
                <AIChatWidget />
                <Toaster
                    position="top-center"
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: "#121212",
                            border: "1px solid #27272A",
                            color: "#fff",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
